// extracted by mini-css-extract-plugin
module.exports = {"FooterSocials":"FooterSocialLinks_FooterSocials__AdX6w","FooterInnerBottomSocial":"FooterSocialLinks_FooterInnerBottomSocial__QEtXt"};